import {
	Box,
	Checkbox,
	Container,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	Button,
	ListSubheader,
} from '@mui/material'
import {useRefinementList, useMenu} from 'react-instantsearch-hooks-web'
import Opportunities from './Opportunities'
import useCurrentSelection from './helpers/useCurrentSelection'
import {useEffect, useContext, useState} from 'react'
import {AppContext} from './Context'
import CloseIcon from '@mui/icons-material/Close'
function Filter() {
	const {shareYourInterests, searchOpportunities} = useContext(AppContext)
	return (
		<Container sx={{mt: '40px'}} maxWidth="lg">
			<Box sx={{display: 'flex', flexDirection: 'column'}}>
				{searchOpportunities && (
					<>
						<FilterBar />
						<Opportunities />
					</>
				)}
			</Box>
		</Container>
	)
}
export default Filter

function FilterBar() {
	const {city, cluster} = useCurrentSelection()

	// Build the sequence: City → Cluster → Availability (single-select)
	let filterMenuConfig = []
	filterMenuConfig.push({type: 'menu', attribute: 'city'})
	if (city.hasSelected) {
		filterMenuConfig.push({type: 'menu', attribute: 'cluster'})
	}
	if (cluster.hasSelected) {
		filterMenuConfig.push({type: 'menu', attribute: 'availability'})
	}

	const filterMenus = filterMenuConfig.map(menu => {
		const Component = menu.type === 'menu' ? FilterMenu : FilterList
		return (
			<Grid item xs={1} key={menu.attribute}>
				<Component attribute={menu.attribute} />
			</Grid>
		)
	})

	// Auto-scroll down when City is chosen
	useEffect(() => {
		if (city.hasSelected) {
			window.scrollBy(0, window.innerHeight)
		}
	}, [city.hasSelected])

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					flexDirection: {xs: 'column', sm: 'column', md: 'row'},
					maxWidth: {md: '94%'},
				}}
			>
				<Grid
					container
					columns={{xs: 1, sm: 2, md: 3}}
					spacing={{xs: 2, sm: 3, md: 1}}
				>
					{filterMenus}
				</Grid>
			</Box>
		</>
	)
}

function FilterList({attribute}) {
	const {items, refine} = useRefinementList({attribute})

	return (
		<>
			<SelectField
				attribute={attribute}
				value={items.filter(v => v.isRefined).map(v => v.value)}
				multiple={true}
				items={items}
			/>
		</>
	)
}

function FilterMenu({attribute}) {
	const {items, refine} = useMenu({attribute})
	return (
		<SelectField
			attribute={attribute}
			value={items.find(v => v.isRefined)?.label ?? ''}
			multiple={false} // single-select for city, cluster, and now availability
			items={items}
			refine={refine}
		/>
	)
}

function SelectField({multiple, attribute, value, items, refine}) {
	const [isOpen, setIsOpen] = useState(false)
	const [openDialog, setOpenDialog] = useState(false)
	const {selectedData, selectedUpcomingCluster, setSelectedUpcomingCluster} =
		useContext(AppContext)

	const handleOpenDialog = () => setOpenDialog(true)

	const handleClose = () => {
		if (
			(attribute === 'cluster' &&
				selectedUpcomingCluster.some(item =>
					item.includes('upcoming cluster:')
				) &&
				!selectedData.current.cluster?.value) ||
			(attribute === 'availability' &&
				selectedUpcomingCluster.some(item =>
					item.includes('upcoming availability:')
				) &&
				!selectedData.current.availability?.value)
		) {
			handleOpenDialog()
		}
		setIsOpen(false)
	}

	const handleOpen = () => {
		setIsOpen(true)
	}

	return (
		<FormControl fullWidth>
			<InputLabel
				id={`${attribute}-menu`}
				style={{textTransform: 'capitalize'}}
			>
				{attribute}
			</InputLabel>
			<Select
				labelId={`${attribute}-menu`}
				id={`${attribute}-select`}
				value={value}
				renderValue={selected =>
					Array.isArray(selected) ? selected.join(', ') : selected
				}
				label={attribute}
				multiple={multiple}
				open={isOpen}
				onClose={handleClose}
				onOpen={handleOpen}
				sx={{
					'& .MuiOutlinedInput-notchedOutline': {
						borderColor: 'rgba(0, 0, 0, 0.23)',
					},
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: 'primary.main',
					},
					'&:hover .MuiOutlinedInput-notchedOutline': {
						borderColor: 'rgba(0, 0, 0, 0.87)',
					},
					'& .MuiSelect-select': {
						paddingRight: '32px !important',
					},
				}}
			>
				<ListSubheader
					style={{
						fontWeight: 'bold',
						color: '#6b7280',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<span>Available</span>
					<Button
						onClick={handleClose}
						style={{
							minWidth: 'auto',
							padding: '4px',
							color: '#1976d2',
						}}
					>
						<CloseIcon />
					</Button>
				</ListSubheader>

				{items.map(item => (
					<MenuItem
						key={item.label}
						value={item.label}
						onClick={() => refine(item.value)}
						style={{
							whiteSpace: 'normal',
							wordBreak: 'break-word',
							padding: '8px 16px',
							'&:hover': {backgroundColor: '#f3f4f6'},
						}}
					>
						{multiple && (
							<Checkbox
								checked={item.isRefined}
								color="primary"
							/>
						)}
						<span style={{flexGrow: 1}}>{item.label}</span>
						{/* <span
							style={{
								color: '#6b7280',
								fontSize: '0.875rem',
								whiteSpace: 'nowrap',
							}}
						>
							({item.count})
						</span> */}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}
